export const GET_SAVED_ITEMS = "GET_SAVED_ITEMS";



// WEBPACK FOOTER //
// ./template/state/modules/savedItems/constants.js